import { useEffect } from 'react';

import { clearUser, setUser } from '@pletly/feature-sentry';
import { useUser } from '%context';

export const useSetSentryUser = () => {
	const user = useUser();
	const userId = user?.id || '';
	const userEmail = user?.email || '';

	useEffect(() => {
		if (!userId) {
			clearUser();

			return () => {};
		}

		setUser({
			id: `${userId}`,
			email: userEmail,
		});
	}, [userId, userEmail]);
};
